import { render } from "./CrStepMass4Content.vue?vue&type=template&id=fb6ba188&scoped=true"
import script from "./CrStepMass4Content.vue?vue&type=script&lang=js"
export * from "./CrStepMass4Content.vue?vue&type=script&lang=js"

import "./CrStepMass4Content.vue?vue&type=style&index=0&id=fb6ba188&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6ba188"]])

export default __exports__